module.exports = __webpack_public_path__ + "img/Celloger Mini Plus.13b53e77.png";